/* global axios */
import ApiClient from './ApiClient';

class ConversationsExportApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  export(params) {
    return this.getCustom('export', params);
  }

  // Filters payload is an array of {attribute_key, filter_operator, values, query_operator}
  // objects (same shape `Conversations::FilterService` already accepts) - sent as a POST
  // body since nested arrays/objects don't serialize reliably as GET query params.
  exportWithFilters({ email, payload }) {
    return axios.post(`${this.url}/export`, { email, payload });
  }
}

export default new ConversationsExportApi();
